// extracted by mini-css-extract-plugin
export var animatedgradient = "meshGradient-module--animatedgradient--36932";